//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GetAboutPage from "~/apollo/queries/getAbout";

export default {
  head() {
    return {title: this.page.aardvark}
  },
  mounted() {
    /* eslint-disable-next-line */
    console.log("The page id: ", this.page.databaseId);
  },
  apollo: {
    page: {
      query: GetAboutPage,
      update(data) {
        data.page.aardvark = data.allSettings.generalSettingsTitle;
        return data.page;
      },
    },
  },
};
